var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOptInOut = function SvgOptInOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "opt-in-out_svg2__a",
    x1: 17.72,
    x2: 182.04,
    y1: 178.4,
    y2: 36.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#opt-in-out_svg2__a",
    id: "opt-in-out_svg2__b",
    x1: 40.57,
    x2: 204.9,
    y1: 204.8,
    y2: 62.49
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#opt-in-out_svg2__a",
    id: "opt-in-out_svg2__c",
    x1: -12.21,
    x2: 152.11,
    y1: 143.84,
    y2: 1.54
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M46.67 120c-18.38 0-33.33 14.95-33.33 33.33s14.95 33.33 33.33 33.33S80 171.71 80 153.33 65.05 120 46.67 120m0 60C31.97 180 20 168.04 20 153.33s11.96-26.67 26.67-26.67 26.67 11.96 26.67 26.67S61.38 180 46.67 180",
    style: {
      fill: "url(#opt-in-out_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.33 106.67H46.67C20.93 106.67 0 127.6 0 153.33S20.93 200 46.67 200h106.67c25.73 0 46.67-20.93 46.67-46.67s-20.93-46.67-46.67-46.67Zm0 86.66H46.67c-22.06 0-40-17.94-40-40s17.94-40 40-40h106.67c22.06 0 40 17.94 40 40s-17.94 40-40 40Z",
    style: {
      strokeWidth: 0,
      fill: "url(#opt-in-out_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.67 93.33h106.67c25.73 0 46.67-20.93 46.67-46.67S179.07 0 153.33 0H46.67C20.93 0 0 20.93 0 46.67s20.93 46.67 46.67 46.67Zm106.66-80c18.38 0 33.33 14.95 33.33 33.33s-14.95 33.33-33.33 33.33S120 65.04 120 46.66s14.95-33.33 33.33-33.33",
    style: {
      strokeWidth: 0,
      fill: "url(#opt-in-out_svg2__c)"
    }
  }));
};
export default SvgOptInOut;